import { MapCanvasValue } from "../components/map/contexts/MapCanvasContext/MapCanvasContext.types";
import { GroupShape, Shape, SpotShape } from "../types";
import { generateShapeId } from "./generateShapeId";

/**
 * Reset a shape for copying into another floor: fresh id, and — like the
 * clipboard paste — spots lose their resource binding so saving the target
 * floor creates new resources instead of stealing the source floor's.
 */
const resetShapeForCopy = (shape: Shape): Shape => {
  const next = { ...shape, id: generateShapeId(shape.type) } as Shape;

  if (next.type === "spot") {
    const spot = next as SpotShape;
    return {
      ...spot,
      resource_id: undefined,
      companions: spot.companions?.map(resetShapeForCopy)
    } as Shape;
  }

  if (next.type === "group" && Array.isArray((next as GroupShape).children)) {
    return {
      ...next,
      children: (next as GroupShape).children.map(resetShapeForCopy)
    } as Shape;
  }

  return next;
};

/**
 * Prepare another floor's map_data for loading into the current editor:
 * every shape gets a new id and every spot is unbound from its resource,
 * so the copied map is a fresh starting point rather than a shared one.
 */
export const sanitizeMapValueForCopy = (
  value: MapCanvasValue
): MapCanvasValue => ({
  ...value,
  shapes: value.shapes.map(resetShapeForCopy)
});
